<template>
  <div>
    <h1 class="text-headline-small text-md-display-medium text-lg-display-large text-xl-display-large text-truncate">Importation des données dans Firebase</h1>
    <v-container class="pt-6">
      <v-row>
        <v-col>
          <v-btn variant="flat" color="secondary" class="mt-3 mr-3" @click="migrateTopos()" :disabled="isLoading"
            >Migrer les Topos</v-btn
          >
          <v-progress-circular v-if="isLoading" indeterminate color="primary" class="mt-3"></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  //import { GaugesService } from "@/store/modules/gauges";
  //import { RegionsService } from "@/store/modules/regions";
  //import { RiversService } from "@/store/modules/rivers";
  //import SectionsService from "@/store/modules/sections";
  //import qww_region from "@/store/db/qww_region";
  //import qww_rivers from "@/store/db/qww_rivers";
  //import qww_sections from "@/store/db/qww_sections";
  //import qww_extrapolation from "@/store/db/qww_extrapolation.db";
  //import qww_gauges from "@/store/db/qww_gauge_list.db";
  //import qww_sections_topo_direction_videos from "@/store/db/qww_sections_topo_direction_videos.db";
  import { /*auth,*/ functions } from "@/firebase";
  //import { db } from "@/firebase";
  //import { mapGetters, mapState } from "vuex";

  export default {
    data() {
      return {
        isLoading: false,
        isLoadingRegion: false,
        isLoadingRiver: false,
        isLoadingSection: false,
        isLoadingGauge: false,
        gauges: [],
        gaugesDB: [],
        gauge_data: "",
        responseResult: "",
        publicPath: process.env.BASE_URL,
      };
    },
    async created() {},
    async mounted() {},
    methods: {
      async updateClaims() {},
      async migrateTopos() {
        this.isLoading = true;
        const migrateTopos = functions.httpsCallable("migrateTopos");
        await migrateTopos()
          .then((result) => {
            console.log("Migration completed:", result.data);
          })
          .catch((error) => {
            console.error("Migration failed:", error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
